import type productId from "./id";

const productEn: typeof productId = {
	product: {
		title: "Product",
		subtitle: "Product List Summary",
		filters: {
			store: "Store",
			all_stores: "All Stores",
			type: "Type",
			all_types: "All Types",
			product: "Product",
			ingredient: "Ingredient",
		},
		detail: {
			back: "Back",
			info_title: "Product Information",
			name: "Product Name",
			category: "Category",
			type: "Type",
			description: "Description",
			online: "Sold Online",
			yes: "Yes",
			no: "No",
			not_found: "Product not found.",
			tabs: {
				variant: "Variant",
				ingredient: "Ingredients",
				history: "Supplier History",
			},
		},
		variant: {
			title: "Product Variants",
			add: "Add Variant",
			edit: "Edit Variant",
			columns: {
				name: "Variant Name",
				barcode: "Barcode",
				price: "Selling Price",
				hpp: "COGS",
				stock: "Stock",
				unit: "Unit",
				status: "Status",
				action: "Action",
			},
			fields: {
				store: "Store",
				name: "Variant Name",
				price: "Selling Price",
				hpp: "COGS (Cost Price)",
				unit: "Unit",
				precision: "Order Qty Precision",
				stock: "Initial Stock",
				with_stock: "Track Stock",
				barcode: "Barcode",
				status: "Status",
				supplier: "Supplier",
				no_supplier: "No Supplier",
			},
			empty_state: {
				title: "No variants yet",
				description: "Add a variant so the product can be sold.",
			},
			add_success: "Variant created",
			edit_success: "Variant updated",
			delete_title: "Delete Variant",
			delete_description:
				"A deleted variant cannot be restored. Delete anyway?",
			delete_success: "Variant deleted",
			errors: {
				store_required: "Store is required",
				name_required: "Variant name is required",
				price_min: "Value cannot be negative",
			},
		},
		ingredient: {
			title: "Ingredients",
			add: "Add Recipe",
			edit: "Edit Recipe",
			variant: "Variant",
			notes: "Notes",
			items: "Composition",
			item_name: "Ingredient Name",
			item_qty: "Qty",
			item_unit: "Unit",
			item_price: "Price",
			add_item: "Add Ingredient",
			remove_item: "Delete",
			empty_state: {
				title: "No recipes yet",
				description:
					"Define the ingredients each variant consumes when the product is sold.",
			},
			add_success: "Recipe saved",
			edit_success: "Recipe updated",
			delete_title: "Delete Recipe",
			delete_description: "A deleted recipe cannot be restored.",
			delete_success: "Recipe deleted",
		},
		history: {
			title: "Supplier Stock History",
			columns: {
				date: "Date",
				supplier: "Supplier",
				variant: "Variant",
				type: "Type",
				qty: "Qty",
				price: "Price",
				total: "Total",
			},
			empty_state: {
				title: "No history yet",
				description:
					"History appears once there are stock transactions from a supplier.",
			},
		},
		common: {
			save: "Save",
			cancel: "Cancel",
			delete: "Delete",
		},
		table: {
			title: "Product Data",
			columns: {
				name: "Product Name",
				category: "Category",
				type: "Type",
				variant_amonunt: { title: "Variant Amount", amount: "variants" },
				price: "Price",
				stock: "Stock",
				status: "Status",
			},
		},
		forms: {
			import: {
				button: "Import Product",
				title: "Import Product",
				description: "Import Product",
			},
			export: {
				toast: {
					success: {
						title: "Success",
						description: "Success to export {rows} rows to excel!",
					},
					failed: {
						title: "Failed",
						description: "Failed to export data to excel!",
					},
				},
			},
			edit: {
				title: "Edit Product",
				description: "Edit Product",
				info: "Product Information",
				fields: {
					name: {
						label: "Product Name",
						placeholder: "Product Name",
					},
					category: {
						label: "Category",
						placeholder: "Category",
					},
					type: {
						label: "Type",
						placeholder: "Type",
					},
					store: {
						label: "Store",
						placeholder: "Store",
					},
					variant: {
						label: "Variant",
						placeholder: "Variant",
					},
					status: {
						label: "Status",
						placeholder: "Status",
					},
				},
				toast: {
					success: {
						title: "Success",
						description: "Success to edit product!",
					},
					failed: {
						title: "Failed",
						description: "Failed to edit product!",
					},
				},
			},
			delete: {
				title: "Delete Product",
				description: "Are you sure want to delete {name}?",
				toast: {
					success: {
						title: "Success",
						description: "Success to delete product!",
					},
					failed: {
						title: "Failed",
						description: "Failed to delete product!",
					},
				},
			},
		},
		empty_state: {
			title: "No Product data",
			description: "Please add a new one.",
		},
		actions: {
			save: "Save",
			save_changes: "Save Changes",
			saving_changes: "Saving Changes...",
			saving: "Saving...",
			delete: "Delete",
			deleting: "Deleting...",
			cancel: "Cancel",
		},
		status: { active: "Active", inactive: "Inactive" },
	},
};

export default productEn;
